import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { eventSearch, deleteEvent } from '../actions';

const Events = (props) => {
    return <div>
      <div className="row">
          <div className="col">
              <h1>Aktiviteter <Link to="/events/add" className="ml-2"><i className="fa-light fa-circle-plus small"></i></Link>
              </h1>
          </div>
      </div>
      <div className="form form-group form-search">
          <input type="text" onChange={props.onSearchChange} value={props.search}  className="form-control" placeholder="Sök på titel, referens eller kund" />
      </div>
      <ul className="list">
          <li className="list-header">
              <div className="row align-items-center">
                  <div className="col"></div>
                  <div className="col-2">
                      Referens
                  </div>
                  <div className="col-2">
                      Tillagd
                  </div>
                  <div className="col-1"></div>
              </div>
          </li>
          {props.events && props.events.map((event, i) => {
              return <li key={i}>
                  <div className="row align-items-center">
                      <div className="col">
                          <h2>{event.title}</h2>
                          <p className="small">{event.client}&nbsp;|&nbsp;{event.contracts}st kontrakt</p>
                          <p className="small"><Link to={ "/registrera/" + event.slug}>Till registrering</Link></p>
                      </div>
                      <div className="col-2">
                          {event.reference}
                      </div>
                      <div className="col-2">
                          {new Date(event.created * 1000).toLocaleDateString()}
                      </div>
                      <div className="col-1 text-right">
                          <div className={props.toggled == event.id ? 'dropdown show d-inline' : 'dropdown  d-inline'}>
                              <a href="#"  onClick={props.onToggle.bind(null, event.id)} data-toggle="dropdown">
                                  Mer <i className="fa-light fa-angle-down small"></i>
                              </a>
                              <div className="dropdown-menu" >
                                  <Link className="dropdown-item" to={"/events/edit/" + event.id}>Redigera</Link>
                                  {false && <a className="dropdown-item" href="#">Arkivera</a>}
                                  <div className="dropdown-divider"></div>
                                  <Link className="dropdown-item" to={"/contracts/filter/" + event.reference}>Visa alla kontrakt</Link>
                                  <div className="dropdown-divider"></div>
                                  <Link className="dropdown-item" to={ "/registrera/" + event.slug}>Skapa nytt kontrakt</Link>
                                  <div className="dropdown-divider"></div>
                                  {event.contracts == 0 && <a className="dropdown-item" onClick={props.toggleDelete} href="#">{props.deleteToggled ? 'Nej, jag ångrar mig' : 'Ta bort'}</a>}
                                  {props.deleteToggled && <a className="dropdown-item text-danger" onClick={props.onDelete.bind(null, event.id)} href="#">Ja, jag vill ta bort</a>}
                                  {event.contracts >0 && <span className="dropdown-item text-disabled">Ta bort (Finns kontrakt)</span>}
                              </div>
                          </div>
                      </div>
                  </div>
              </li>
          })}
      </ul>
      </div>;
}

export default connect(store => store.eventState, (dispatch) => {
    return {
        onSearchChange: (e) => {
            eventSearch(dispatch, e.target.value);
        },
        onToggle: (id, e) => {
            e.preventDefault();
            dispatch({
                type: 'EVENT_DROPDOWN_TOGGLE',
                id: id
            });
        },
        toggleDelete: (e) => {
            e.preventDefault();
            dispatch({
                type: 'EVENT_TOGGLE_DELETE'
            })
        },
        onDelete: (id, e) => {
            e.preventDefault();
            deleteEvent(dispatch, id);
        }
    }
})(Events);
